// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root {\n  --spacing-0: 0px;\n  --spacing-1: 2px;\n  --spacing-2: 4px;\n  --spacing-3: 8px;\n  --spacing-4: 12px;\n  --spacing-5: 16px;\n  --spacing-6: 24px;\n  --spacing-7: 32px;\n  --spacing-8: 40px;\n  --spacing-9: 48px;\n  --spacing-10: 56px;\n  --spacing-11: 64px;\n  --spacing-12: 72px;\n  --spacing-13: 80px;\n}\n", ""]);
// Exports
module.exports = exports;
